<template>
  <div class="pagingComponent">
    <el-pagination
      @current-change="handleCurrentChange"
      background
      layout="prev, pager, next"
      :page-count="total"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    rows: {
      type: Number,
      default: 10,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  watch:{},
  methods: {
    handleCurrentChange(val) {
      this.$emit("handleCurrentChangeSub", val);
    },
  }
};
</script>
<style>
.block .el-input .el-input__inner {
  width: 100% !important;
}
.block .el-input {
  min-width: 60px !important;
}
</style>
<style scoped>
.pagingComponent {
  margin: 30px auto;
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
